import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import _defineProperty from '@babel/runtime-corejs3/helpers/esm/defineProperty';
import _pt from 'prop-types';
import 'react';
import { filterDataAttributes } from '@commercetools-uikit/utils';
import { css } from '@emotion/react';
import { customProperties } from '@commercetools-uikit/design-system';
import { jsx } from '@emotion/react/jsx-runtime';

var getAlignItem = function getAlignItem(alignment) {
  switch (alignment) {
    case 'flexStart':
      return "flex-start";

    case 'flexEnd':
      return "flex-end";

    default:
      return alignment;
  }
};

var getMargin = function getMargin(scale) {
  switch (scale) {
    case 'xs':
      return customProperties.spacingXs;

    case 's':
      return customProperties.spacingS;

    case 'm':
      return customProperties.spacingM;

    case 'l':
      return customProperties.spacingL;

    case 'xl':
      return customProperties.spacingXl;

    default:
      return 0;
  }
};
/**
 * We need to force the margin for the child elements as ome children
 * might have `margin: 0` defined, which results in a higher CSS specificity,
 * causing the margings of the spacing components to be ignored.
 * See https://github.com/commercetools/ui-kit/issues/542
 */


var getStyles = function getStyles(props) {
  return /*#__PURE__*/css("display:flex;flex-direction:column;align-items:", getAlignItem(props.alignItems), ";>*+*{margin:", getMargin(props.scale), " 0 0!important;}" + (process.env.NODE_ENV === "production" ? "" : ";label:getStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0YWNrLnN0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUF1Q3dDIiwiZmlsZSI6InN0YWNrLnN0eWxlcy50cyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB0eXBlIHsgVEFsaWduSXRlbSwgVFNjYWxlLCBUUHJvcHMgfSBmcm9tICcuL3N0YWNrJztcblxuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgY3VzdG9tUHJvcGVydGllcyBhcyB2YXJzIH0gZnJvbSAnQGNvbW1lcmNldG9vbHMtdWlraXQvZGVzaWduLXN5c3RlbSc7XG5cbmNvbnN0IGdldEFsaWduSXRlbSA9IChhbGlnbm1lbnQ/OiBUQWxpZ25JdGVtKSA9PiB7XG4gIHN3aXRjaCAoYWxpZ25tZW50KSB7XG4gICAgY2FzZSAnZmxleFN0YXJ0JzpcbiAgICAgIHJldHVybiBgZmxleC1zdGFydGA7XG4gICAgY2FzZSAnZmxleEVuZCc6XG4gICAgICByZXR1cm4gYGZsZXgtZW5kYDtcbiAgICBkZWZhdWx0OlxuICAgICAgcmV0dXJuIGFsaWdubWVudDtcbiAgfVxufTtcblxuY29uc3QgZ2V0TWFyZ2luID0gKHNjYWxlPzogVFNjYWxlKSA9PiB7XG4gIHN3aXRjaCAoc2NhbGUpIHtcbiAgICBjYXNlICd4cyc6XG4gICAgICByZXR1cm4gdmFycy5zcGFjaW5nWHM7XG4gICAgY2FzZSAncyc6XG4gICAgICByZXR1cm4gdmFycy5zcGFjaW5nUztcbiAgICBjYXNlICdtJzpcbiAgICAgIHJldHVybiB2YXJzLnNwYWNpbmdNO1xuICAgIGNhc2UgJ2wnOlxuICAgICAgcmV0dXJuIHZhcnMuc3BhY2luZ0w7XG4gICAgY2FzZSAneGwnOlxuICAgICAgcmV0dXJuIHZhcnMuc3BhY2luZ1hsO1xuICAgIGRlZmF1bHQ6XG4gICAgICByZXR1cm4gMDtcbiAgfVxufTtcblxuLyoqXG4gKiBXZSBuZWVkIHRvIGZvcmNlIHRoZSBtYXJnaW4gZm9yIHRoZSBjaGlsZCBlbGVtZW50cyBhcyBvbWUgY2hpbGRyZW5cbiAqIG1pZ2h0IGhhdmUgYG1hcmdpbjogMGAgZGVmaW5lZCwgd2hpY2ggcmVzdWx0cyBpbiBhIGhpZ2hlciBDU1Mgc3BlY2lmaWNpdHksXG4gKiBjYXVzaW5nIHRoZSBtYXJnaW5ncyBvZiB0aGUgc3BhY2luZyBjb21wb25lbnRzIHRvIGJlIGlnbm9yZWQuXG4gKiBTZWUgaHR0cHM6Ly9naXRodWIuY29tL2NvbW1lcmNldG9vbHMvdWkta2l0L2lzc3Vlcy81NDJcbiAqL1xuY29uc3QgZ2V0U3R5bGVzID0gKHByb3BzOiBUUHJvcHMpID0+IGNzc2BcbiAgZGlzcGxheTogZmxleDtcbiAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgYWxpZ24taXRlbXM6ICR7Z2V0QWxpZ25JdGVtKHByb3BzLmFsaWduSXRlbXMpfTtcblxuICA+ICogKyAqIHtcbiAgICBtYXJnaW46ICR7Z2V0TWFyZ2luKHByb3BzLnNjYWxlKX0gMCAwICFpbXBvcnRhbnQ7XG4gIH1cbmA7XG5cbmV4cG9ydCBkZWZhdWx0IGdldFN0eWxlcztcbiJdfQ== */");
};

var getStyles$1 = getStyles;

function ownKeys(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context;

      _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context2;

      _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var Stack = function Stack(props) {
  return jsx("div", _objectSpread(_objectSpread({
    css: getStyles$1(props)
  }, filterDataAttributes(props)), {}, {
    children: props.children
  }));
};

Stack.propTypes = process.env.NODE_ENV !== "production" ? {
  scale: _pt.oneOf(['xs', 's', 'm', 'l', 'xl']).isRequired,
  alignItems: _pt.oneOf(['stretch', 'flex-start', 'flex-end', 'center', 'baseline', 'flexStart', 'flexEnd']).isRequired,
  children: _pt.node.isRequired
} : {};
var defaultProps = {
  scale: 's',
  alignItems: 'stretch'
};
Stack.displayName = 'Stack';
Stack.defaultProps = defaultProps;
var Stack$1 = Stack; // NOTE: This string will be replaced on build time with the package version.

var version = "12.2.9";
export { Stack$1 as default, version };